import get from 'lodash/get';
import noop from 'lodash/noop';
import { createStore, applyMiddleware, compose } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import ComponentInterfaceManager from 'lib/ComponentInterfaceManager';
import splashPageEpics from './modules/epics';

/**
 * @param {function} reducers - initial reducers for store creation.
 * @return {Object} - redux store.
 */
const createComponentInterfaceManagerInstance = () => {
    const epicMiddleware = createEpicMiddleware();
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const cim = new ComponentInterfaceManager({
        store: createStore(
            noop,
            composeEnhancers(applyMiddleware(thunkMiddleware, promiseMiddleware(), epicMiddleware)),
        ),
    });

    epicMiddleware.run(splashPageEpics);

    return cim;
};

/**
 * Returns the redux store either grabbed from the parent frame, workspace, when in edit mode; or
 * by creating it when frame is loaded separately.
 *
 * @return {Object} - { store, componentInterfaceManager }
 */
export default (insideEditingIframe) => {
    const componentInterfaceManager = insideEditingIframe
        ? get(window.parent, 'SPLASH.Workspace.componentInterfaceManager')
        : createComponentInterfaceManagerInstance();

    const store = componentInterfaceManager.getStore();

    return { store, componentInterfaceManager };
};
